import { render } from "./TrfWizardModuloEmpresas.vue?vue&type=template&id=8987425a"
import script from "./TrfWizardModuloEmpresas.vue?vue&type=script&lang=js"
export * from "./TrfWizardModuloEmpresas.vue?vue&type=script&lang=js"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/WizardConfiguracaoPendente/TrfWizardModuloEmpresas.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8987425a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8987425a', __exports__)) {
    console.log('reload')
    api.reload('8987425a', __exports__)
  }
  
  module.hot.accept("./TrfWizardModuloEmpresas.vue?vue&type=template&id=8987425a", () => {
    console.log('re-render')
    api.rerender('8987425a', render)
  })

}


export default __exports__